import Vue from "vue";
import router from "../router";
import App from "../App.vue";
import _store from "store";
import store from "../store";
import i18n from "../lang"; // Internationalization

_store.set("initState", store.state);

// 主应用渲染函数
let app = null;

export function render({ appContent, loading } = {}) {
  if (!app) {
    app = new Vue({
      el: "#container",
      router,
      store,
      i18n,
      data() {
        return {
          content: appContent,
          loading
        };
      },
      render(h) {
        return h(App, {
          props: {
            content: this.content,
            loading: this.loading
          }
        });
      }
    });
  } else {
    app.content = appContent;
    app.loading = loading;
  }
}
